import React from 'react';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { Grid } from 'semantic-ui-react';
import MoreVert from '@material-ui/icons/MoreVert';
import Server from '../../functions/server'
import $ from "jquery";
import Dialogbox from './dialogbox';
import Loading from '../loading';
import { Link } from 'react-router-dom';
import Release from '../../functions/release';

class Purchaserequest extends React.Component {

  state = {
    data: [],
    open: false
  }

  getToday() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if(dd < 10) { dd = '0' + dd; }
    if(mm < 10) { mm = '0' + mm; }
    today = yyyy+'-'+mm+'-'+dd;
    return today;
  }

  startingMonth() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if(dd < 10) { dd = '0' + dd; }
    if(mm < 10) { mm = '0' + mm; }
    let fromMonth = yyyy+'-'+mm+'-01';
    return fromMonth;
  }

  startingYear() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if(dd < 10){ dd = '0' + dd; }
    if(mm < 10){ mm = '0' + mm; }
    let fromYear = yyyy+'-01-01';
    return fromYear;
  }

  viewBranch(type, value) {
    let context = this;
    let today = this.getToday();
    let startingMonth = this.startingMonth();
    let staringYear = this.startingYear();
    context.setState({ load: true, message: 'Getting Values' })
    $.ajax({
      type: 'POST',
      data: { 'today': today, 'startingMonth': startingMonth, 'staringYear': staringYear, 'type': type, 'value': value },
      url: Server() + 'dashboard/purchaserequestbranch.php',
      success: function(data) {
        try {
          data = JSON.parse(data);
          context.setState({ data: data, open: true, load: false })
        } catch (e) {
          context.setState({ load: false });
        }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  render() {
    let waitingpurchaseRequest, waitingpurchaseRequestAmount, longwaitingpurchaseRequest, longwaitingpurchaseRequestAmount;
    let samplepurchaseRequest, samplepurchaseRequestAmount;
    let data = this.props.data.map((x) => {
      waitingpurchaseRequest = x.purchase_request_waiting;
      waitingpurchaseRequestAmount = x.purchase_request_waiting_amount;
      longwaitingpurchaseRequest = x.purchase_request_longwaiting;
      longwaitingpurchaseRequestAmount = x.purchase_request_longwaiting_amount;
      samplepurchaseRequest = x.sample_pending_stocks;
      samplepurchaseRequestAmount =  x.sample_pending_amount;
    });
    if (waitingpurchaseRequest == null) {
      waitingpurchaseRequest = 0;
      longwaitingpurchaseRequest = 0;
      samplepurchaseRequest = 0;
    }
    waitingpurchaseRequestAmount = Number(waitingpurchaseRequestAmount);
    waitingpurchaseRequestAmount = waitingpurchaseRequestAmount.toFixed(2);
    longwaitingpurchaseRequestAmount = Number(longwaitingpurchaseRequestAmount);
    longwaitingpurchaseRequestAmount = longwaitingpurchaseRequestAmount.toFixed(2);
    samplepurchaseRequestAmount = Number(samplepurchaseRequestAmount);
    samplepurchaseRequestAmount = samplepurchaseRequestAmount.toFixed(2);
    let fontSize = 25;

    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        <Grid>
          <Grid.Column mobile={16} tablet={16} computer={16}>
            <Card style={{backgroundColor: '#abb119'}}>
              <div style={{display: 'flex', padding: '2%'}}>
                <div style={{fontSize: 17, color: 'white'}}><b>Purchase Request</b></div>
                <div style={{paddingLeft: '59%', color: 'white', fontSize: 17, display: 'none'}}><MoreVert style={{cursor: 'pointer'}} /></div>
              </div>
              <Grid>
                <Grid.Column mobile={16} tablet={16} computer={5}>
                  <Link to={"/"+Release()+"/purchase-details"}>
                    <CardContent>
                        <div style={{color: 'white'}}>Waiting Request<br/></div>
                        <b style={{color: 'white', paddingTop: '4%', fontSize: fontSize}}>{waitingpurchaseRequest}</b><br/>
                        <b style={{color: 'white', paddingTop: '4%', fontSize: 14}}>{"₹"+waitingpurchaseRequestAmount}</b>
                    </CardContent>
                  </Link>
                  <CardActions>
                    <Button size="small" onClick={this.viewBranch.bind(this, 'month', 'Waiting')} style={{color: 'white'}}>View Branch</Button>
                  </CardActions>
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={5}>
                  <Link to={"/"+Release()+"/purchase-details"}>
                    <CardContent>
                        <div style={{color: 'white'}}>Long Waiting Request<br/></div>
                        <b style={{color: 'white', paddingTop: '4%', fontSize: fontSize}}>{longwaitingpurchaseRequest}</b><br/>
                        <b style={{color: 'white', paddingTop: '4%', fontSize: 14}}>{"₹"+longwaitingpurchaseRequestAmount}</b>
                    </CardContent>
                  </Link>
                  <CardActions>
                    <Button size="small" onClick={this.viewBranch.bind(this, 'month', 'Long Waiting')} style={{color: 'white'}}>View Branch</Button>
                  </CardActions>
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={5}>
                  <Link to={"/"+Release()+"/purchase-details"}>
                    <CardContent>
                        <div style={{color: 'white'}}>Sample Purchase Request<br/></div>
                        <b style={{color: 'white', paddingTop: '4%', fontSize: fontSize}}>{samplepurchaseRequest}</b><br/>
                        <b style={{color: 'white', paddingTop: '4%', fontSize: 14}}>{"₹"+samplepurchaseRequestAmount}</b>
                    </CardContent>
                  </Link>
                  <CardActions>
                    <Button size="small" onClick={this.viewBranch.bind(this, 'month', 'All')} style={{color: 'white'}}>View Branch</Button>
                  </CardActions>
                </Grid.Column>
              </Grid>
            </Card>
          </Grid.Column>
        </Grid>
        { this.state.open ?
          (
            <div>
              <Dialogbox col2="Branch" col3="Item(s)" type="stock" data={this.state.data} open={this.state.open} handleClose={ () => { this.setState({ open: false }) }} title='Purchase Report' />
            </div>
          ) : ''
        }
      </div>
    );
  }
}

export default Purchaserequest;
